(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["NINI_2026_main-product"]) return;
  try {
    
// previous code // previous code // previous code 
// document.addEventListener('DOMContentLoaded', function () {
//   const productTitle = document.querySelector('.product-title'); // Product title element
//   const colorRadios = document.querySelectorAll('input[name^="Color-"]'); // Select all color radio buttons
//   let flkty; // Define Flickity instance

//   // Function to initialize Flickity
//   function initializeFlickity() {
//     const elem = document.querySelector('.js-media-sublist');
    
//     // Initialize Flickity
//     flkty = new Flickity(elem, {
//       cellAlign: 'left',
//       contain: true,
//       pageDots: false,
//       wrapAround: true // For continuous looping
//     });

//     // Hook up buttons
//     // const prevButton = document.getElementById('prev-button');
//     // const nextButton = document.getElementById('next-button');

//     // if (prevButton && nextButton) {
//     //   prevButton.addEventListener('click', function () {
//     //     flkty.previous();
//     //   });

//     //   nextButton.addEventListener('click', function () {
//     //     flkty.next();
//     //   });
//     // }
//   }

//   // Function to update the product title with the selected color
//   function updateProductTitle(selectedColor) {
//     // Fetch product variant data via Ajax
//     fetch(`${window.location.pathname}.js`)
//       .then(response => response.json())
//       .then(product => {
//         // Find the variant that matches the selected color
//         const selectedVariant = product.variants.find(variant => variant.option1 === selectedColor);

//         if (selectedVariant) {
//           // Update the product title with the selected color in uppercase
//           productTitle.innerHTML = `${product.title} IN ${selectedColor.toUpperCase()}`;
          
//           // Reinitialize Flickity after updating the title
//           flkty.destroy(); // Destroy the previous Flickity instance
//           initializeFlickity(); // Re-initialize Flickity to ensure buttons are present
//         }
//       })
//       .catch(error => console.error('Error fetching product variant data:', error));
//   }

//   // Check if there's a default checked radio button and update the title accordingly
//   const defaultCheckedRadio = document.querySelector('input[name^="Color-"]:checked');
//   if (defaultCheckedRadio) {
//     const defaultColor = defaultCheckedRadio.value; // Get the default color value
//     updateProductTitle(defaultColor); // Update title with the default color
//   }

//   // Add change event listeners for color radio buttons
//   colorRadios.forEach(radio => {
//     radio.addEventListener('change', function (event) {
//       const selectedColor = event.target.value; // Get the value of the selected color
//       updateProductTitle(selectedColor); // Update title with the selected color
//     });
//   });

//   // Initialize Flickity initially
//   initializeFlickity();
// });


// // document.addEventListener('DOMContentLoaded', function() {
// //   var images = document.querySelectorAll('.main-image');
// //   var totalImages = images.length;
// //   var loadedImages = 0;

// //   images.forEach(function(image) {
// //     image.onload = function() {
// //       loadedImages++;
// //       if (loadedImages === totalImages) {
// //         // Initialize Flickity or slider
// //         var elem = document.querySelector('.product__media-sublist');
// //         var flkty = new Flickity(elem, {
// //           asNavFor: '.product__media-list',
// //           contain: true,
// //           pageDots: false,
// //           prevNextButtons: false
// //         });
// //       }
// //     };
// //   });
// // });


//   const product_collaps = document.querySelectorAll('#product_collaps_wrapper .product__additional');
//             const collaps_des= document.getElementsByClassName('product__additional-description');
//   const collaps_items = Array.from(product_collaps);
//   collaps_items.forEach(item=>{item.addEventListener('click', (e) => {
//   console.log(item);
//     if(item.classList.contains('active')){
//       const collaps_content = item.childNodes[3];
//       console.log(collaps_items)
//       const arrowIcon = item.childNodes[1].childNodes[1];
      
//       if(collaps_content.classList.contains('hidden')){
//         collaps_content.classList.remove('hidden');
//         collaps_content.style.transition='0.25s all'
        
//         arrowIcon.style.transform='rotate(90deg)';
//         const marginbtm = document.querySelector('.margin-btm');
// marginbtm.style.marginBottom = '1100px';

//       }else{
//         collaps_content.classList.add('hidden');
//         arrowIcon.style.transform='rotate(0deg)';
//         const marginbtm = document.querySelector('.margin-btm');
// marginbtm.style.marginBottom = '';

//       }
      
//     }
//     });})

// //   document.getElementsByClassName('toggleButton').addEventListener('click', function() {
// //     var content = document.getElementByClassName('content');
// //     if (content.classList.contains('hidden')) {
// //         content.classList.remove('hidden');
// //         // this.textContent = 'Hide Content';
// //     } else {
// //         content.classList.add('hidden');
// //         // this.textContent = 'Show Content';
// //     }
// // });

// class ProductModal extends ModalDialog {
// 	constructor() {
// 		super();
// 	}

// 	hide() {
// 		super.hide();
// 		window.pauseAllMedia();
// 	}

// 	show(opener) {
// 		super.show(opener);
// 		this.showActiveMedia();
// 	}

// 	showActiveMedia() {
// 		this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
// 				// element.classList.remove('active');
// 			}
// 		)
// 		const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
// 		// activeMedia.classList.add('active');
// 		activeMedia.scrollIntoView();

// 		if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube'))
// 			activeMedia.loadContent();
// 	}
// }

// class ProductRecommendations extends HTMLElement {
// 	constructor() {
// 		super();

// 		const handleIntersection = (entries, observer) => {
      
// 			if (!entries[0].isIntersecting) return;
// 			observer.unobserve(this);

// 			fetch(this.dataset.url)
// 				.then(response => response.text())
// 				.then(text => {
// 					const html = document.createElement('div');
// 					html.innerHTML = text;
// 					const recommendations = html.querySelector('product-recommendations--single');
// 					if (recommendations && recommendations.innerHTML.trim().length) {
// 						this.innerHTML = recommendations.innerHTML;
// 					}
// 				})
// 				.catch(e => {
// 					console.error(e);
// 				});
// 		}

// 		new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
// 	}
// }

// customElements.define('product-modal', ProductModal);
// customElements.define('product-recommendations--single', ProductRecommendations);

// $(document).ready(function () {
// 	if ($('.product-section') && $('.product-section').length > 0) {
		

// 		// 1st carousel, main
// 		$('.product__media-list').flickity({
// 			pageDots: false,
// 			prevNextButtons: false,
// 			adaptiveHeight: true,
// 			wrapAround: true,
// 			on: {
// 				select: function( index ) {

// 					let slides = $( ".product__media-list .product__media-item");

// 					var iframe = $(slides[index]).find('iframe');

// 					var allIframes = $('.product__media-list').find('iframe');
// 					var video = $(slides[index]).find('video');
// 					var allVideos = $('.product__media-list').find('video');

// 					if (video && video.length > 0) {
// 						video.get(0).play();
// 					} else if (allVideos && allVideos.length > 0) {
// 						allVideos.get(0).pause();
// 					}

// 					if (iframe && iframe.length > 0) {
// 						iframe[0].contentWindow.postMessage(JSON.stringify({"event": "command", "func": "playVideo"}), '*');
// 					} else if (allIframes && allIframes.length > 0) {
// 						allIframes[0].contentWindow.postMessage(JSON.stringify({"event": "command", "func": "pauseVideo"}), '*');
// 					} else {
// 						return false;
// 					}
// 				}
// 			}
// 		});

// 		$('.product__media-list-wrapper-outer-arrow_prev').on( 'click', function() {
// 			$('.product__media-list').flickity('previous');
// 		});
// 		$('.product__media-list-wrapper-outer-arrow_next').on( 'click', function() {
// 			$('.product__media-list').flickity('next');
// 		});


// 		$('.product__media-sublist').flickity({
// 			asNavFor: '.product__media-list',
// 			contain: true,
// 			pageDots: false,
// 			prevNextButtons: false
			
// 		});
// 	}
// })
// previous code  // previous code // previous code // previous code 

// for client

document.addEventListener('DOMContentLoaded', function() {
    const form = document.getElementById('redirect-radio-form');
    
    if (form) {
      form.addEventListener('change', function(event) {
        if (event.target.name === 'redirectOption') {
          const selectedUrl = event.target.value;  // URL saved in the metafield
          window.location.href = selectedUrl;  // Redirect to the selected URL
        }
      });
    } else {
      console.error('Form with ID redirect-radio-form not found.');
    }
  });



document.addEventListener('DOMContentLoaded', function () {
  const productTitle = document.querySelector('.product-title'); // Product title element
  const colorRadios = document.querySelectorAll('input[name^="Color-"]'); // Select all color radio buttons
  let flkty; // Define Flickity instance

  // Function to initialize Flickity
  function initializeFlickity() {
    const elem = document.querySelector('.js-media-sublist');
    
    // Initialize Flickity
    flkty = new Flickity(elem, {
      cellAlign: 'left',
      contain: true,
      pageDots: false,
      wrapAround: true // For continuous looping
    });

    // Hook up buttons
    // const prevButton = document.getElementById('prev-button');
    // const nextButton = document.getElementById('next-button');

    // if (prevButton && nextButton) {
    //   prevButton.addEventListener('click', function () {
    //     flkty.previous();
    //   });

    //   nextButton.addEventListener('click', function () {
    //     flkty.next();
    //   });
    // }
  }

  // Function to update the product title with the selected color
  function updateProductTitle(selectedColor) {
    // Fetch product variant data via Ajax
    fetch(`${window.location.pathname}.js`)
      .then(response => response.json())
      .then(product => {
        // Find the variant that matches the selected color
        const selectedVariant = product.variants.find(variant => variant.option1 === selectedColor);

        if (selectedVariant) {
          // Update the product title with the selected color in uppercase
          // productTitle.innerHTML = `${product.title} IN ${selectedColor.toUpperCase()}`;
          
          // Reinitialize Flickity after updating the title
          flkty.destroy(); // Destroy the previous Flickity instance
          initializeFlickity(); // Re-initialize Flickity to ensure buttons are present
        }
      })
      .catch(error => console.error('Error fetching product variant data:', error));
  }

  // Check if there's a default checked radio button and update the title accordingly
  const defaultCheckedRadio = document.querySelector('input[name^="Color-"]:checked');
  if (defaultCheckedRadio) {
    const defaultColor = defaultCheckedRadio.value; // Get the default color value
    updateProductTitle(defaultColor); // Update title with the default color
  }

  // Add change event listeners for color radio buttons
  colorRadios.forEach(radio => {
    radio.addEventListener('change', function (event) {
      const selectedColor = event.target.value; // Get the value of the selected color
      updateProductTitle(selectedColor); // Update title with the selected color
    });
  });

  // Initialize Flickity initially
  initializeFlickity();
});


document.addEventListener('DOMContentLoaded', function() {
  var images = document.querySelectorAll('.main-image');
  var totalImages = images.length;
  var loadedImages = 0;

  images.forEach(function(image) {
    image.onload = function() {
      loadedImages++;
      if (loadedImages === totalImages) {
        // Initialize Flickity or slider
        var elem = document.querySelector('.product__media-sublist');
        var flkty = new Flickity(elem, {
          asNavFor: '.product__media-list',
          contain: true,
          pageDots: false,
          prevNextButtons: false
        });
      }
    };
  });
});


  const product_collaps = document.querySelectorAll('#product_collaps_wrapper .product__additional');
            const collaps_des= document.getElementsByClassName('product__additional-description');
  const collaps_items = Array.from(product_collaps);
  collaps_items.forEach(item=>{item.addEventListener('click', (e) => {
     const marginbtm = document.querySelector('.margin-btm');
        marginbtm.style.marginBottom = '';
  console.log("eeeeeeeeeee",item);
    if(item.classList.contains('active')){
      const collaps_content = item.childNodes[3];
      console.log("aaaaaaaa",collaps_items)
      const arrowIcon = item.childNodes[1].childNodes[1];
     
      if(collaps_content.classList.contains('hidden')){
        
        collaps_content.classList.remove('hidden');
        collaps_content.style.transition='0.25s all'
        
        arrowIcon.style.transform='rotate(90deg)';


      }else{
        const marginbtm = document.querySelector('.margin-btm');
        marginbtm.style.marginBottom = '';
        collaps_content.classList.add('hidden');
        arrowIcon.style.transform='rotate(0deg)';
 

      }
      
    }
    });})








//   document.getElementsByClassName('toggleButton').addEventListener('click', function() {
//     var content = document.getElementByClassName('content');
//     if (content.classList.contains('hidden')) {
//         content.classList.remove('hidden');
//         // this.textContent = 'Hide Content';
//     } else {
//         content.classList.add('hidden');
//         // this.textContent = 'Show Content';
//     }
// });

class ProductModal extends ModalDialog {
	constructor() {
		super();
	}

	hide() {
		super.hide();
		window.pauseAllMedia();
	}

	show(opener) {
		super.show(opener);
		this.showActiveMedia();
	}

	showActiveMedia() {
		this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
				element.classList.remove('active');
			}
		)
		const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
		activeMedia.classList.add('active');
		activeMedia.scrollIntoView();

		if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube'))
			activeMedia.loadContent();
	}
}

class ProductRecommendations extends HTMLElement {
	constructor() {
		super();

		const handleIntersection = (entries, observer) => {
      
			if (!entries[0].isIntersecting) return;
			observer.unobserve(this);

			fetch(this.dataset.url)
				.then(response => response.text())
				.then(text => {
					const html = document.createElement('div');
					html.innerHTML = text;
					const recommendations = html.querySelector('product-recommendations--single');
					if (recommendations && recommendations.innerHTML.trim().length) {
						this.innerHTML = recommendations.innerHTML;
					}
				})
				.catch(e => {
					console.error(e);
				});
		}

		new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
	}
}

customElements.define('product-modal', ProductModal);
customElements.define('product-recommendations--single', ProductRecommendations);

$(document).ready(function () {
    if ($('.product-section').length > 0) {

        // Main carousel initialization
        var $mainCarousel = $('.product__media-list').flickity({
            pageDots: false,
            prevNextButtons: false,
            adaptiveHeight: true,
            wrapAround: true
        });

        // Sublist carousel initialization
        var $sublistCarousel = $('.product__media-sublist').flickity({
            contain: true,
            pageDots: false,
            prevNextButtons: false,
            draggable: true,
            cellAlign: 'left'
        });

        // Manually handle sublist click event to update main carousel
        $sublistCarousel.on('staticClick.flickity', function(event, pointer, cellElement, cellIndex) {
            if (!cellElement) {
                return; // Exit if no cellElement
            }

            console.log('Sublist item clicked: ', cellIndex);
            // Update main carousel to the clicked sublist item
            $mainCarousel.flickity('select', cellIndex);
        });

        // Navigation arrow controls for the main carousel
        $('.product__media-list-wrapper-outer-arrow_prev').on('click', function() {
            $mainCarousel.flickity('previous');
        });
        $('.product__media-list-wrapper-outer-arrow_next').on('click', function() {
            $mainCarousel.flickity('next');
        });
    }
});

$('.product__media-sublist').on('staticClick.flickity', function(event, pointer, cellElement, cellIndex) {
    if (cellElement) {
        console.log('Sublist item clicked: ', cellIndex);
    }
});



document.addEventListener("DOMContentLoaded", function () {
    const titles = document.querySelectorAll(".product__additional-title");
    const descriptions = document.querySelectorAll(".product__additional-description.rte");
    const section1 = document.getElementById("shopify-section-template--18854198149377__1737526447d987a8a8");
    const section2 = document.getElementById("shopify-section-template--18854198149377__product-recommendations");

    if (titles.length >= 3 && descriptions.length >= 3) {
        // Toggle for titles[2]
        titles[2].addEventListener("click", function () {
            descriptions[2].style.marginBottom = "20px"; // Change '20px' to your desired margin

            // Toggle the blur effect
            if (section1 && section2) {
                const isBlurred = section1.style.filter === "blur(10px)";
                const newFilter = isBlurred ? "none" : "blur(10px)";
                
                section1.style.filter = newFilter;
                section2.style.filter = newFilter;
            }
        });

        // Toggle for titles[1]
        titles[1].addEventListener("click", function () {
            descriptions[1].style.marginBottom = "20px"; // Change '20px' to your desired margin

            // Toggle the blur effect
            if (section1 && section2) {
                const isBlurred = section1.style.filter === "blur(10px)";
                const newFilter = isBlurred ? "none" : "blur(10px)";
                
                section1.style.filter = newFilter;
                section2.style.filter = newFilter;
            }
        });
    }
});







  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      this.elements.input.value = event.currentTarget.dataset.value;
      this.querySelector('form')?.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute(
        'aria-expanded',
        (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
      );
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
class StickyHeader extends HTMLElement {
constructor() {
super();
}

connectedCallback() {
this.header = document.querySelector('.shopify-section-header');
this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
this.headerBounds = {};
this.currentScrollTop = 0;
this.preventReveal = false;

if (this.headerIsAlwaysSticky) {
this.header.classList.add('shopify-section-header-sticky');
};

this.onScrollHandler = this.onScroll.bind(this);
this.hideHeaderOnScrollUp = () => this.preventReveal = true;
this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
window.addEventListener('scroll', this.onScrollHandler, false);

this.createObserver();
}

disconnectedCallback() {
this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
window.removeEventListener('scroll', this.onScrollHandler);
}

createObserver() {
let observer = new IntersectionObserver((entries, observer) => {
this.headerBounds = entries[0].intersectionRect;
observer.disconnect();
});

observer.observe(this.header);
}

onScroll() {
const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
if (this.preventHide) return;
requestAnimationFrame(this.hide.bind(this));
} else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
if (!this.preventReveal) {
requestAnimationFrame(this.reveal.bind(this));
} else {
window.clearTimeout(this.isScrolling);

this.isScrolling = setTimeout(() => {
this.preventReveal = false;
}, 66);

requestAnimationFrame(this.hide.bind(this));
}
} else if (scrollTop <= this.headerBounds.top) {
requestAnimationFrame(this.reset.bind(this));
}

this.currentScrollTop = scrollTop;
}

hide() {
if (this.headerIsAlwaysSticky) return;
this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
this.closeMenuDisclosure();
this.closeSearchModal();
}

reveal() {
if (this.headerIsAlwaysSticky) return;
this.header.classList.add('shopify-section-header-sticky', 'animate');
this.header.classList.add('shopify-section-header-sticky', 'animate');
this.header.classList.remove('shopify-section-header-hidden');
}

reset() {
if (this.headerIsAlwaysSticky) return;
this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
}

closeMenuDisclosure() {
this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
this.disclosures.forEach(disclosure => disclosure.close());
}

closeSearchModal() {
this.searchModal = this.searchModal || this.header.querySelector('details-modal');
this.searchModal.close(false);
}
}

customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
class CartNote extends HTMLElement {
	constructor() {
		super();

		this.addEventListener('change', debounce((event) => {
			const body = JSON.stringify({note: event.target.value});
			fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{body}});
		}, 300))
	}
}

customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
// previous code // previous code // previous code 
// document.addEventListener('DOMContentLoaded', function () {
//   const productTitle = document.querySelector('.product-title'); // Product title element
//   const colorRadios = document.querySelectorAll('input[name^="Color-"]'); // Select all color radio buttons
//   let flkty; // Define Flickity instance

//   // Function to initialize Flickity
//   function initializeFlickity() {
//     const elem = document.querySelector('.js-media-sublist');
    
//     // Initialize Flickity
//     flkty = new Flickity(elem, {
//       cellAlign: 'left',
//       contain: true,
//       pageDots: false,
//       wrapAround: true // For continuous looping
//     });

//     // Hook up buttons
//     // const prevButton = document.getElementById('prev-button');
//     // const nextButton = document.getElementById('next-button');

//     // if (prevButton && nextButton) {
//     //   prevButton.addEventListener('click', function () {
//     //     flkty.previous();
//     //   });

//     //   nextButton.addEventListener('click', function () {
//     //     flkty.next();
//     //   });
//     // }
//   }

//   // Function to update the product title with the selected color
//   function updateProductTitle(selectedColor) {
//     // Fetch product variant data via Ajax
//     fetch(`${window.location.pathname}.js`)
//       .then(response => response.json())
//       .then(product => {
//         // Find the variant that matches the selected color
//         const selectedVariant = product.variants.find(variant => variant.option1 === selectedColor);

//         if (selectedVariant) {
//           // Update the product title with the selected color in uppercase
//           productTitle.innerHTML = `${product.title} IN ${selectedColor.toUpperCase()}`;
          
//           // Reinitialize Flickity after updating the title
//           flkty.destroy(); // Destroy the previous Flickity instance
//           initializeFlickity(); // Re-initialize Flickity to ensure buttons are present
//         }
//       })
//       .catch(error => console.error('Error fetching product variant data:', error));
//   }

//   // Check if there's a default checked radio button and update the title accordingly
//   const defaultCheckedRadio = document.querySelector('input[name^="Color-"]:checked');
//   if (defaultCheckedRadio) {
//     const defaultColor = defaultCheckedRadio.value; // Get the default color value
//     updateProductTitle(defaultColor); // Update title with the default color
//   }

//   // Add change event listeners for color radio buttons
//   colorRadios.forEach(radio => {
//     radio.addEventListener('change', function (event) {
//       const selectedColor = event.target.value; // Get the value of the selected color
//       updateProductTitle(selectedColor); // Update title with the selected color
//     });
//   });

//   // Initialize Flickity initially
//   initializeFlickity();
// });


// // document.addEventListener('DOMContentLoaded', function() {
// //   var images = document.querySelectorAll('.main-image');
// //   var totalImages = images.length;
// //   var loadedImages = 0;

// //   images.forEach(function(image) {
// //     image.onload = function() {
// //       loadedImages++;
// //       if (loadedImages === totalImages) {
// //         // Initialize Flickity or slider
// //         var elem = document.querySelector('.product__media-sublist');
// //         var flkty = new Flickity(elem, {
// //           asNavFor: '.product__media-list',
// //           contain: true,
// //           pageDots: false,
// //           prevNextButtons: false
// //         });
// //       }
// //     };
// //   });
// // });


//   const product_collaps = document.querySelectorAll('#product_collaps_wrapper .product__additional');
//             const collaps_des= document.getElementsByClassName('product__additional-description');
//   const collaps_items = Array.from(product_collaps);
//   collaps_items.forEach(item=>{item.addEventListener('click', (e) => {
//   console.log(item);
//     if(item.classList.contains('active')){
//       const collaps_content = item.childNodes[3];
//       console.log(collaps_items)
//       const arrowIcon = item.childNodes[1].childNodes[1];
      
//       if(collaps_content.classList.contains('hidden')){
//         collaps_content.classList.remove('hidden');
//         collaps_content.style.transition='0.25s all'
        
//         arrowIcon.style.transform='rotate(90deg)';
//         const marginbtm = document.querySelector('.margin-btm');
// marginbtm.style.marginBottom = '1100px';

//       }else{
//         collaps_content.classList.add('hidden');
//         arrowIcon.style.transform='rotate(0deg)';
//         const marginbtm = document.querySelector('.margin-btm');
// marginbtm.style.marginBottom = '';

//       }
      
//     }
//     });})

// //   document.getElementsByClassName('toggleButton').addEventListener('click', function() {
// //     var content = document.getElementByClassName('content');
// //     if (content.classList.contains('hidden')) {
// //         content.classList.remove('hidden');
// //         // this.textContent = 'Hide Content';
// //     } else {
// //         content.classList.add('hidden');
// //         // this.textContent = 'Show Content';
// //     }
// // });

// class ProductModal extends ModalDialog {
// 	constructor() {
// 		super();
// 	}

// 	hide() {
// 		super.hide();
// 		window.pauseAllMedia();
// 	}

// 	show(opener) {
// 		super.show(opener);
// 		this.showActiveMedia();
// 	}

// 	showActiveMedia() {
// 		this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
// 				// element.classList.remove('active');
// 			}
// 		)
// 		const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
// 		// activeMedia.classList.add('active');
// 		activeMedia.scrollIntoView();

// 		if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube'))
// 			activeMedia.loadContent();
// 	}
// }

// class ProductRecommendations extends HTMLElement {
// 	constructor() {
// 		super();

// 		const handleIntersection = (entries, observer) => {
      
// 			if (!entries[0].isIntersecting) return;
// 			observer.unobserve(this);

// 			fetch(this.dataset.url)
// 				.then(response => response.text())
// 				.then(text => {
// 					const html = document.createElement('div');
// 					html.innerHTML = text;
// 					const recommendations = html.querySelector('product-recommendations--single');
// 					if (recommendations && recommendations.innerHTML.trim().length) {
// 						this.innerHTML = recommendations.innerHTML;
// 					}
// 				})
// 				.catch(e => {
// 					console.error(e);
// 				});
// 		}

// 		new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
// 	}
// }

// customElements.define('product-modal', ProductModal);
// customElements.define('product-recommendations--single', ProductRecommendations);

// $(document).ready(function () {
// 	if ($('.product-section') && $('.product-section').length > 0) {
		

// 		// 1st carousel, main
// 		$('.product__media-list').flickity({
// 			pageDots: false,
// 			prevNextButtons: false,
// 			adaptiveHeight: true,
// 			wrapAround: true,
// 			on: {
// 				select: function( index ) {

// 					let slides = $( ".product__media-list .product__media-item");

// 					var iframe = $(slides[index]).find('iframe');

// 					var allIframes = $('.product__media-list').find('iframe');
// 					var video = $(slides[index]).find('video');
// 					var allVideos = $('.product__media-list').find('video');

// 					if (video && video.length > 0) {
// 						video.get(0).play();
// 					} else if (allVideos && allVideos.length > 0) {
// 						allVideos.get(0).pause();
// 					}

// 					if (iframe && iframe.length > 0) {
// 						iframe[0].contentWindow.postMessage(JSON.stringify({"event": "command", "func": "playVideo"}), '*');
// 					} else if (allIframes && allIframes.length > 0) {
// 						allIframes[0].contentWindow.postMessage(JSON.stringify({"event": "command", "func": "pauseVideo"}), '*');
// 					} else {
// 						return false;
// 					}
// 				}
// 			}
// 		});

// 		$('.product__media-list-wrapper-outer-arrow_prev').on( 'click', function() {
// 			$('.product__media-list').flickity('previous');
// 		});
// 		$('.product__media-list-wrapper-outer-arrow_next').on( 'click', function() {
// 			$('.product__media-list').flickity('next');
// 		});


// 		$('.product__media-sublist').flickity({
// 			asNavFor: '.product__media-list',
// 			contain: true,
// 			pageDots: false,
// 			prevNextButtons: false
			
// 		});
// 	}
// })
// previous code  // previous code // previous code // previous code 

// for client

document.addEventListener('DOMContentLoaded', function() {
    const form = document.getElementById('redirect-radio-form');
    
    if (form) {
      form.addEventListener('change', function(event) {
        if (event.target.name === 'redirectOption') {
          const selectedUrl = event.target.value;  // URL saved in the metafield
          window.location.href = selectedUrl;  // Redirect to the selected URL
        }
      });
    } else {
      console.error('Form with ID redirect-radio-form not found.');
    }
  });



document.addEventListener('DOMContentLoaded', function () {
  const productTitle = document.querySelector('.product-title'); // Product title element
  const colorRadios = document.querySelectorAll('input[name^="Color-"]'); // Select all color radio buttons
  let flkty; // Define Flickity instance

  // Function to initialize Flickity
  function initializeFlickity() {
    const elem = document.querySelector('.js-media-sublist');
    
    // Initialize Flickity
    flkty = new Flickity(elem, {
      cellAlign: 'left',
      contain: true,
      pageDots: false,
      wrapAround: true // For continuous looping
    });

    // Hook up buttons
    // const prevButton = document.getElementById('prev-button');
    // const nextButton = document.getElementById('next-button');

    // if (prevButton && nextButton) {
    //   prevButton.addEventListener('click', function () {
    //     flkty.previous();
    //   });

    //   nextButton.addEventListener('click', function () {
    //     flkty.next();
    //   });
    // }
  }

  // Function to update the product title with the selected color
  function updateProductTitle(selectedColor) {
    // Fetch product variant data via Ajax
    fetch(`${window.location.pathname}.js`)
      .then(response => response.json())
      .then(product => {
        // Find the variant that matches the selected color
        const selectedVariant = product.variants.find(variant => variant.option1 === selectedColor);

        if (selectedVariant) {
          // Update the product title with the selected color in uppercase
          // productTitle.innerHTML = `${product.title} IN ${selectedColor.toUpperCase()}`;
          
          // Reinitialize Flickity after updating the title
          flkty.destroy(); // Destroy the previous Flickity instance
          initializeFlickity(); // Re-initialize Flickity to ensure buttons are present
        }
      })
      .catch(error => console.error('Error fetching product variant data:', error));
  }

  // Check if there's a default checked radio button and update the title accordingly
  const defaultCheckedRadio = document.querySelector('input[name^="Color-"]:checked');
  if (defaultCheckedRadio) {
    const defaultColor = defaultCheckedRadio.value; // Get the default color value
    updateProductTitle(defaultColor); // Update title with the default color
  }

  // Add change event listeners for color radio buttons
  colorRadios.forEach(radio => {
    radio.addEventListener('change', function (event) {
      const selectedColor = event.target.value; // Get the value of the selected color
      updateProductTitle(selectedColor); // Update title with the selected color
    });
  });

  // Initialize Flickity initially
  initializeFlickity();
});


document.addEventListener('DOMContentLoaded', function() {
  var images = document.querySelectorAll('.main-image');
  var totalImages = images.length;
  var loadedImages = 0;

  images.forEach(function(image) {
    image.onload = function() {
      loadedImages++;
      if (loadedImages === totalImages) {
        // Initialize Flickity or slider
        var elem = document.querySelector('.product__media-sublist');
        var flkty = new Flickity(elem, {
          asNavFor: '.product__media-list',
          contain: true,
          pageDots: false,
          prevNextButtons: false
        });
      }
    };
  });
});


  const product_collaps = document.querySelectorAll('#product_collaps_wrapper .product__additional');
            const collaps_des= document.getElementsByClassName('product__additional-description');
  const collaps_items = Array.from(product_collaps);
  collaps_items.forEach(item=>{item.addEventListener('click', (e) => {
     const marginbtm = document.querySelector('.margin-btm');
        marginbtm.style.marginBottom = '';
  console.log("eeeeeeeeeee",item);
    if(item.classList.contains('active')){
      const collaps_content = item.childNodes[3];
      console.log("aaaaaaaa",collaps_items)
      const arrowIcon = item.childNodes[1].childNodes[1];
     
      if(collaps_content.classList.contains('hidden')){
        
        collaps_content.classList.remove('hidden');
        collaps_content.style.transition='0.25s all'
        
        arrowIcon.style.transform='rotate(90deg)';


      }else{
        const marginbtm = document.querySelector('.margin-btm');
        marginbtm.style.marginBottom = '';
        collaps_content.classList.add('hidden');
        arrowIcon.style.transform='rotate(0deg)';
 

      }
      
    }
    });})








//   document.getElementsByClassName('toggleButton').addEventListener('click', function() {
//     var content = document.getElementByClassName('content');
//     if (content.classList.contains('hidden')) {
//         content.classList.remove('hidden');
//         // this.textContent = 'Hide Content';
//     } else {
//         content.classList.add('hidden');
//         // this.textContent = 'Show Content';
//     }
// });

class ProductModal extends ModalDialog {
	constructor() {
		super();
	}

	hide() {
		super.hide();
		window.pauseAllMedia();
	}

	show(opener) {
		super.show(opener);
		this.showActiveMedia();
	}

	showActiveMedia() {
		this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
				element.classList.remove('active');
			}
		)
		const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
		activeMedia.classList.add('active');
		activeMedia.scrollIntoView();

		if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube'))
			activeMedia.loadContent();
	}
}

class ProductRecommendations extends HTMLElement {
	constructor() {
		super();

		const handleIntersection = (entries, observer) => {
      
			if (!entries[0].isIntersecting) return;
			observer.unobserve(this);

			fetch(this.dataset.url)
				.then(response => response.text())
				.then(text => {
					const html = document.createElement('div');
					html.innerHTML = text;
					const recommendations = html.querySelector('product-recommendations--single');
					if (recommendations && recommendations.innerHTML.trim().length) {
						this.innerHTML = recommendations.innerHTML;
					}
				})
				.catch(e => {
					console.error(e);
				});
		}

		new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
	}
}

customElements.define('product-modal', ProductModal);
customElements.define('product-recommendations--single', ProductRecommendations);

$(document).ready(function () {
    if ($('.product-section').length > 0) {

        // Main carousel initialization
        var $mainCarousel = $('.product__media-list').flickity({
            pageDots: false,
            prevNextButtons: false,
            adaptiveHeight: true,
            wrapAround: true
        });

        // Sublist carousel initialization
        var $sublistCarousel = $('.product__media-sublist').flickity({
            contain: true,
            pageDots: false,
            prevNextButtons: false,
            draggable: true,
            cellAlign: 'left'
        });

        // Manually handle sublist click event to update main carousel
        $sublistCarousel.on('staticClick.flickity', function(event, pointer, cellElement, cellIndex) {
            if (!cellElement) {
                return; // Exit if no cellElement
            }

            console.log('Sublist item clicked: ', cellIndex);
            // Update main carousel to the clicked sublist item
            $mainCarousel.flickity('select', cellIndex);
        });

        // Navigation arrow controls for the main carousel
        $('.product__media-list-wrapper-outer-arrow_prev').on('click', function() {
            $mainCarousel.flickity('previous');
        });
        $('.product__media-list-wrapper-outer-arrow_next').on('click', function() {
            $mainCarousel.flickity('next');
        });
    }
});

$('.product__media-sublist').on('staticClick.flickity', function(event, pointer, cellElement, cellIndex) {
    if (cellElement) {
        console.log('Sublist item clicked: ', cellIndex);
    }
});



document.addEventListener("DOMContentLoaded", function () {
    const titles = document.querySelectorAll(".product__additional-title");
    const descriptions = document.querySelectorAll(".product__additional-description.rte");
    const section1 = document.getElementById("shopify-section-template--18854198149377__1737526447d987a8a8");
    const section2 = document.getElementById("shopify-section-template--18854198149377__product-recommendations");

    if (titles.length >= 3 && descriptions.length >= 3) {
        // Toggle for titles[2]
        titles[2].addEventListener("click", function () {
            descriptions[2].style.marginBottom = "20px"; // Change '20px' to your desired margin

            // Toggle the blur effect
            if (section1 && section2) {
                const isBlurred = section1.style.filter === "blur(10px)";
                const newFilter = isBlurred ? "none" : "blur(10px)";
                
                section1.style.filter = newFilter;
                section2.style.filter = newFilter;
            }
        });

        // Toggle for titles[1]
        titles[1].addEventListener("click", function () {
            descriptions[1].style.marginBottom = "20px"; // Change '20px' to your desired margin

            // Toggle the blur effect
            if (section1 && section2) {
                const isBlurred = section1.style.filter === "blur(10px)";
                const newFilter = isBlurred ? "none" : "blur(10px)";
                
                section1.style.filter = newFilter;
                section2.style.filter = newFilter;
            }
        });
    }
});







  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product2"]) return;
  try {
    

  const product_collaps = document.querySelectorAll('#product_collaps_wrapper .product__additional');
  const collaps_des= document.getElementsByClassName('product__additional-description');
  const collaps_items = Array.from(product_collaps);
  collaps_items.forEach(item=>{item.addEventListener('click', () => {
    if(item.classList.contains('active')){
      const collaps_content = item.childNodes[3];
      console.log(collaps_items)
      const arrowIcon = item.childNodes[1].childNodes[1];
      
      if(collaps_content.classList.contains('hidden')){
        collaps_content.classList.remove('hidden');
        collaps_content.style.transition='0.25s all'
        arrowIcon.style.transform='rotate(90deg)';
      }else{
        collaps_content.classList.add('hidden');
        arrowIcon.style.transform='rotate(0deg)';
      }
      
    }
    });})

//   document.getElementsByClassName('toggleButton').addEventListener('click', function() {
//     var content = document.getElementByClassName('content');
//     if (content.classList.contains('hidden')) {
//         content.classList.remove('hidden');
//         // this.textContent = 'Hide Content';
//     } else {
//         content.classList.add('hidden');
//         // this.textContent = 'Show Content';
//     }
// });

class ProductModal extends ModalDialog {
	constructor() {
		super();
	}

	hide() {
		super.hide();
		window.pauseAllMedia();
	}

	show(opener) {
		super.show(opener);
		this.showActiveMedia();
	}

	showActiveMedia() {
		this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
				// element.classList.remove('active');
			}
		)
		const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
		// activeMedia.classList.add('active');
		activeMedia.scrollIntoView();

		if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube'))
			activeMedia.loadContent();
	}
}

class ProductRecommendations extends HTMLElement {
	constructor() {
		super();

		const handleIntersection = (entries, observer) => {
			if (!entries[0].isIntersecting) return;
			observer.unobserve(this);

			fetch(this.dataset.url)
				.then(response => response.text())
				.then(text => {
					const html = document.createElement('div');
					html.innerHTML = text;
					const recommendations = html.querySelector('product-recommendations--single');
					if (recommendations && recommendations.innerHTML.trim().length) {
						this.innerHTML = recommendations.innerHTML;
					}
				})
				.catch(e => {
					console.error(e);
				});
		}

		new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
	}
}

customElements.define('product-modal', ProductModal);
customElements.define('product-recommendations--single', ProductRecommendations);

$(document).ready(function () {
	if ($('.product-section') && $('.product-section').length > 0) {
		

		// 1st carousel, main
		$('.product__media-list').flickity({
			pageDots: false,
			prevNextButtons: false,
			adaptiveHeight: true,
			wrapAround: true,
			on: {
				select: function( index ) {

					let slides = $( ".product__media-list .product__media-item");

					var iframe = $(slides[index]).find('iframe');

					var allIframes = $('.product__media-list').find('iframe');
					var video = $(slides[index]).find('video');
					var allVideos = $('.product__media-list').find('video');

					if (video && video.length > 0) {
						video.get(0).play();
					} else if (allVideos && allVideos.length > 0) {
						allVideos.get(0).pause();
					}

					if (iframe && iframe.length > 0) {
						iframe[0].contentWindow.postMessage(JSON.stringify({"event": "command", "func": "playVideo"}), '*');
					} else if (allIframes && allIframes.length > 0) {
						allIframes[0].contentWindow.postMessage(JSON.stringify({"event": "command", "func": "pauseVideo"}), '*');
					} else {
						return false;
					}
				}
			}
		});

		$('.product__media-list-wrapper-outer-arrow_prev').on( 'click', function() {
			$('.product__media-list').flickity('previous');
		});
		$('.product__media-list-wrapper-outer-arrow_next').on( 'click', function() {
			$('.product__media-list').flickity('next');
		});


		$('.product__media-sublist').flickity({
			asNavFor: '.product__media-list',
			contain: true,
			pageDots: false,
			prevNextButtons: false,
			cellAlign: 'left'
		});
	}
})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
